module.exports = __webpack_public_path__ + "img/Hewlett-Packard Finance.3b9381bc.png";